<template>

  <div>

    <div style="display: flex;justify-content: flex-start; align-items: center; margin-left: 0.2rem; margin-top: 0.2rem;font-size:0.4rem;"
>
      <div>only unhandled</div>
       <van-switch @change="onOnlyLoadNewChange" style="margin-left:0.2rem; " v-model="onlyLoadNew" />


    </div>

    

     

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model:loading="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div
  v-for="item in list"
  :key="item.id"
  style="margin-bottom: 8px; cursor: pointer;"
>
  <div
    style="display: flex; align-items: center; justify-content: space-between; background: #f8f8f8; padding: 12px 16px; border-radius: 6px;"
    @click.stop
  >


  <div style="flex: 1; font-size: 0.4rem;">
      <div>{{ item.id }}</div>
   
</div>
  
    <!-- 左侧：ID 和 Type -->
    <div style="flex: 3; font-size: 0.4rem;">
      
      <div
  style="
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;

    margin-top: 4px;
    margin-bottom: 4px;
  "
>
      <van-tag plain 
    
    type="success"
    size="medium"
    style="margin-bottom: 4px;"
  >
    {{ item.userId }}
  </van-tag>
  <van-tag plain  v-if="item.rewardType == 2" type="primary" size="medium">评论官</van-tag>
  <van-tag  plain v-if="item.rewardType == 1" type="primary" size="medium">评论回馈</van-tag>
  <van-tag plain 
    v-if="item.rewardType == 1 && item.appStoreId"
    type="success"
    size="medium"
    style="margin-top: 4px;"
  >
    {{ getAppStoreText(item.appStoreId) }}
  </van-tag>

  <van-tag plain 
    v-if="item.rewardType == 2 && item.sharePlatform"
    type="success"
    size="medium"
    style="margin-top: 4px;"
  >
    {{ getsharePlatform(item.sharePlatform) }}
  </van-tag>

  <van-tag plain 
   
    type="success"
    size="medium"
    style="margin-top: 4px;"
  >
    {{ formatDate(item.applyDate) }}
  </van-tag>

  <van-tag 
    v-if="item.rewardType == 2 && item.shareUrl"
    type="success"
    size="medium"
    style="margin-top: 4px; cursor: pointer;"
    @click.stop="openShareUrl(item.shareUrl)"
  >
    查看链接
  </van-tag>


      </div>
      
    
    </div>
    <!-- 中间：图片 -->
    <div @click.stop="previewImg(item.filePath)" style="flex: 3; text-align: center;">
      <img
        :src="getFirstImg(item.filePath)"
        
        style="width: 50px; height: 50px; object-fit: cover; border-radius: 4px;"
      />
    </div>
    <!-- 右侧：操作按钮 -->
    <div style="flex: 3; display: flex; flex-direction: column; gap: 8px;">
      <van-button v-if="(!item.isHandle && !item.isDelete)" size="small" type="danger" @click.stop="onDelete(item)">delete</van-button>
      
      <van-button
        size="small"
        :type="(item.isHandle && item.rewardCount > 0 ) || item.isDelete ? 'default' : 'primary'"
        @click.stop="onAddCoin(item)"
      >
  {{ item.isDelete ? 'deleted' : (item.isHandle && item.rewardCount > 0 ? `+${item.rewardCount}coin` : 'add coin') }}
      </van-button>
          
    </div>
  </div>
</div>
        
      </van-list>
    </van-pull-refresh>

    <van-popup
      v-model:show="showSharedUrl"
      position="bottom"
      :style="{ height: '60%' }"
      closeable
    >

    <div v-if="showSharedUrl" style="max-height: 100%; overflow-y: auto; padding: 16px;">

      <div style="margin-bottom: 12px;">
        <div style="font-size: 0.5rem; margin-bottom: 8px;">分享链接：</div>
        <div style="font-size: 0.4rem; word-break: break-all;">{{ currentShareUrl }}</div>
      </div>


    </div>

      




   
    </van-popup>
    <van-popup
      v-model:show="showImgPreview"
      position="bottom"
      :style="{ height: '90%' }"
      closeable
    >

    <div v-if="previewImgUrl" style="max-height: 100%; overflow-y: auto; padding: 16px;">

          <img
        :src="getFirstImg(previewImgUrl)"
        style="max-width: 90vw; max-height: 80vh; display: block; margin: 0 auto;"
      />

    </div>

      
    </van-popup>

    <van-popup
      v-model:show="showAddCoin"
      position="bottom"
      :style="{ height: '60%' }"
      closeable
    >

  

      <div v-if="showAddCoin" style="max-height: 100%; overflow-y: auto; padding: 16px;">

        <van-field v-if="!currentEditItem.isHandle" style="font-size: 0.4rem" label="奖励硬币:" v-model="coinvalue" readonly clickable @touchstart.stop="showkeyboard = true" />
        <van-button v-if="!currentEditItem.isHandle"
          type="primary"
          style="width:85%; margin-top:0.1rem;"
          @click="showkeyboard = true"

          @click.stop="onApproveReward()"

        >保存</van-button>

       <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; font-size: 0.4rem; margin-top: 0.5rem;" v-if="userRewardCoinApprovedHistory.length">
  <div
    v-for="approvedRewardItem in userRewardCoinApprovedHistory"
    :key="approvedRewardItem.id"
:style="{
    display: 'flex',
    flexDirection: 'row',
    gap: '0.5rem',
    alignItems: 'center',
    borderBottom: '1px solid #eee',
    paddingBottom: '8px',
    color: approvedRewardItem.id === currentEditItem.id ? 'red' : 'black'
  }" 
  >
    <div>{{ formatDate(approvedRewardItem.rewardDate) || '-' }}</div>
    <div>{{ approvedRewardItem.rewardCount || '-' }}</div>
    <div>{{ approvedRewardItem.rewardType == 2 ? "分享官" : "评论回馈" }}</div>
    <van-button @click.stop="deleteApprovedAward(approvedRewardItem)" plain size="small" type="default">{{ approvedRewardItem.isDelete ? '已删除' : '删除' }}</van-button>
  </div>
</div>
        <div style="font-size: 0.4rem" v-else>暂无获取硬币数据</div>



        
        
        <van-number-keyboard
          v-model="coinvalue"
          :show="showkeyboard"
          :maxlength="6"
          @blur="showkeyboard = false"
        />





          
      </div>
    </van-popup>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { showToast } from 'vant';

import api from '@/api/api.js'; // 假设 api.js 导出 api 实例

const FILE_BASE_API = api.defaults.fileBaseURL; // 从 api 实例获取 baseURL
console.log('FILE_BASE_API:', FILE_BASE_API);

//  getPagedRewardApplyDataById 
import { getPagedRewardApplyData,getPagedRewardApplyDataById,approveAwardById,deleteApprovedAwardById} from '@/api/apiService';

const list = ref([]);
const pageNum = ref(1);
const pageSize = ref(10);
const loading = ref(false);
const finished = ref(false);
const refreshing = ref(false);

const showAddCoin = ref(false);
const showSharedUrl = ref(false);
const currentEditItem = ref();

const currentShareUrl = ref('');


const showImgPreview = ref(false);
const previewImgUrl = ref('');
const onlyLoadNew = ref(true);
// function handleImgError(event) {
//   event.target.src = '';
// }


function formatDate(date) {
  if (!date) return '-';
  const d = new Date(date);
  return d.toISOString().split('T')[0]; // 格式化为 YYYY-MM-DD
}


const appStoreMap = [
  { text: '苹果', value: 1 },
  { text: '小米', value: 2 },
  { text: 'oppo', value: 3 },
  { text: '华为', value: 4 },
  { text: 'vivo', value: 5 },
  { text: '应用宝', value: 6 },
  { text: '荣耀', value: 6 },
  { text: '其它', value: 7 }
];

const sharePlatformMap = [
  { text: '小红书', value: 1 },
  { text: 'b站', value: 2 },
  { text: '抖音', value: 3 }
  
];

function getAppStoreText(id) {
  const found = appStoreMap.find(item => item.value == id);
  return found ? found.text : '未知';
}

function getsharePlatform(id) {
  const found = sharePlatformMap.find(item => item.value == id);
  return found ? found.text : '未知';
}
const fetchData = async (isRefresh = false) => {
  if (loading.value) return;
  loading.value = true;
  try {
    const params = {
      page: pageNum.value,
      size: pageSize.value,
      onlyUnhandled: onlyLoadNew.value ? 1 : 0
    };
    const res = await getPagedRewardApplyData(params);
    const records = res.useCoinInfo?.records || [];
    if (isRefresh) {
      list.value = records;
    } else {
      list.value = list.value.concat(records);
    }
    finished.value = list.value.length >= (res.useCoinInfo?.total || 0);
  } catch (e) {
    // 错误处理
  } finally {
    loading.value = false;
    if (refreshing.value) refreshing.value = false;
  }
};



const userRewardCoinApprovedHistory = ref([]);
const showkeyboard = ref(false);
    const coinvalue = ref('200');
const onAddCoin = async (item) => {
  coinvalue.value = '200'; 
  // currentEditItemId.value = item.id;
  currentEditItem.value = item;
  // 添加硬币逻辑
  console.log('添加硬币', item);
  showAddCoin.value = true;


  try {
    const userId = item.userId;
    const params = { userId };
    const res = await getPagedRewardApplyDataById(params);
    // 假设返回数据结构为 res.useCoinInfo.records
    //将currentItemData对应id的记录排第一个
    
    // userRewardCoinApprovedHistory.value = res.useCoinInfo || [];

    userRewardCoinApprovedHistory.value = (res.useCoinInfo || []).slice().sort((a, b) => {
  if (a.id === item.id) return -1;
  if (b.id === item.id) return 1;
  return 0;
});


  } catch (e) {
    console.log('获取用户奖励硬币记录失败', e);
    userRewardCoinApprovedHistory.value = [];
  }




};

const deleteClicks1 = ref(new Map());

const onDelete = async (item) => {
  // 删除逻辑
  console.log('删除', item);
   // 只保留当前 id 的点击记录，其余全部清除
  deleteClicks1.value = new Map([[item.id, deleteClicks1.value.get(item.id) || []]]);

  const clicks = deleteClicks1.value.get(item.id) || [];
  

  clicks.push(Date.now());
  if (clicks.length > 5) clicks.shift();
  deleteClicks1.value.set(item.id, clicks);

  if (clicks.length === 5 && clicks[4] - clicks[0] <= 12000) {


    const response = await deleteApprovedAwardById({ id: item.id });

    if (response && response.code == 0) {
      console.log('删除记录成功:', response);
      item.isDelete = true;
      item.isHandle = false;
      showToast('删除记录成功');
    }else{
      console.log('删除记录失败:', response);
      showToast('删除记录失败');
      return;
    }

    

    

  }else {
    showToast(`还需要 ${5 - clicks.length} 次点击`);
  }

  


};

const deleteClicks = ref(new Map());

const deleteApprovedAward = async (approvedRewardItem) => {

  if(approvedRewardItem.isDelete) return;


    // 只保留当前 id 的点击记录，其余全部清除
  deleteClicks.value = new Map([[approvedRewardItem.id, deleteClicks.value.get(approvedRewardItem.id) || []]]);

  const clicks = deleteClicks.value.get(approvedRewardItem.id) || [];
  

  clicks.push(Date.now());
  if (clicks.length > 5) clicks.shift();
  deleteClicks.value.set(approvedRewardItem.id, clicks);

  if (clicks.length === 5 && clicks[4] - clicks[0] <= 12000) {
    // 发送删除逻辑，将isDelete设为true isHandle设为false ,清除UserCorn中对应的记录

    const response = await deleteApprovedAwardById({ id: approvedRewardItem.id });

    if (response && response.code == 0) {
      console.log('删除奖励硬币记录成功:', response);
      showToast('删除奖励硬币记录成功');
    userRewardCoinApprovedHistory.value = userRewardCoinApprovedHistory.value.filter(d => d.id !== approvedRewardItem.id);

    //查找list中与approvedRewardItem.id相同的条目，并将isDelete设为true isHandle设为false
    const listItem = list.value.find(d => d.id === approvedRewardItem.id);
      if (listItem) {
      listItem.isDelete = true;
      listItem.isHandle = false;
      }

      if(currentEditItem.value && currentEditItem.value.id === approvedRewardItem.id){
        currentEditItem.value.isDelete = true;
        currentEditItem.value.isHandle = false;
      }
      showAddCoin.value = false;
   
    } else {
      console.log('删除奖励硬币记录失败:', response);
      return;
    }



    

  } else {
    showToast(`还需要 ${5 - clicks.length} 次点击`);
  }
};

const onApproveReward = async ()=>{
  // 确认添加硬币逻辑
  console.log('确认添加硬币:', coinvalue.value);
  showToast(`已添加 ${coinvalue.value} 硬币`);
  showAddCoin.value = false;
  //找到条目 并将 isHandle 设为 true



  const response = await approveAwardById({ id: currentEditItem.value.id, rewardCount: Number(coinvalue.value) });

  console.log('approveAwardById response', response);



  

  if(currentEditItem.value){
    currentEditItem.value.isHandle = true;
    currentEditItem.value.rewardCount = Number(coinvalue.value);
    currentEditItem.value.isDelete = false;
  }

}
const onLoad = async () => {
  pageNum.value += 1;
  await fetchData();
};

const onRefresh = async () => {
  finished.value = false;
  pageNum.value = 1;
  await fetchData(true);
};

function previewImg(url) {
  previewImgUrl.value = url;
  showImgPreview.value = true;
}
function openShareUrl(url) {
  // 复制到剪切板
  if (navigator.clipboard) {
    navigator.clipboard.writeText(url).then(() => {
      // 可选：复制成功提示
      showToast('链接已复制到剪切板');
    });
  }
  currentShareUrl.value = url;
  showSharedUrl.value = true;
}


function getFirstImg(imgUrl) {
  if (!imgUrl) return '';
  let url = '';
  if (Array.isArray(imgUrl)) {
    url = imgUrl[0];
  } else if (typeof imgUrl === 'string') {
    try {
      // 尝试解析为数组
      const arr = JSON.parse(imgUrl);
      if (Array.isArray(arr)) {
        url = arr[0];
      } else {
        url = imgUrl.split(',')[0];
      }
    } catch {
      url = imgUrl.split(',')[0];
    }
  }
  console.log('FILE_BASE_API:', FILE_BASE_API); 
  return url ? FILE_BASE_API + url : '';
}

const onOnlyLoadNewChange = (val) => {
  // val 是切换后的布尔值
  console.log('onlyLoadNew changed:', val);
  // 这里可以执行你需要的逻辑，比如刷新数据
  fetchData(true);
};



onRefresh(); // 初始化加载
</script>

  
  <style scoped>

  

  .page_container {
    display: flex;
    flex-direction: column;
    align-content: center;
    
  }

 

    
    
  .submit_title{
    font-size: 0.5rem;
    
    margin-bottom: 0.6rem;
    color: #0a0eeb;
    text-align: left;
    
  }
  .submit_main_body{
    font-size: 0.4rem;
    color:#848488;
    width: 100%;
    align-items: flex-start;
    margin-left: 1rem;
    margin-bottom: 0.2rem;
    
    text-align: left;
  }


  .submit_first_class_tilte{
    font-size: 0.4rem;
    color:#0606e6;
    width: 100%;
    align-items: flex-start;
    margin-left: 1rem;
    margin-top: 0.2rem;
    
    text-align: left;
  }







  </style>